import { Link, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { ComponentProps } from 'react'
import { Link as RouterLink } from 'react-router'
import { useQuery } from 'urql'
import { graphql } from '../gql'

export default function OrgSummary(props: ComponentProps<typeof TableContainer>) {
  const orgQuery = graphql(`
    query OrgSummaryQuery {
      Organization {
        name
        userCount
        clientCount
        projectCount
        vendorCount
      }
    }
  `)

  const [orgQueryRes] = useQuery({ query: orgQuery })
  return (
    <TableContainer {...props}>
      <Table aria-label="org summary">
        <TableBody>
          <TableRow>
            <TableCell>
              <Link component={RouterLink} to="/org">
                Users
              </Link>
            </TableCell>
            <TableCell>{orgQueryRes.data?.Organization.userCount || 0}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Link component={RouterLink} to="/clients">
                Clients
              </Link>
            </TableCell>
            <TableCell>{orgQueryRes.data?.Organization.clientCount || 0}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Link component={RouterLink} to="/projects">
                Projects
              </Link>
            </TableCell>
            <TableCell>{orgQueryRes.data?.Organization.projectCount || 0}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ borderBottom: 'none' }}>
              <Link component={RouterLink} to="/vendors">
                Vendors
              </Link>
            </TableCell>
            <TableCell sx={{ borderBottom: 'none' }}>{orgQueryRes.data?.Organization.vendorCount || 0}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
